export default {
    useMicroIntegration(integrationKey) {
        return ['salesforce'].includes(integrationKey);
    },

    hasStringId(integrationKey) {
        return ['salesforce'].includes(integrationKey);
    },
};
